import { makeStyles } from '@material-ui/styles'

import Theme from '@refera/ui-core'

export default makeStyles(({ spacing, palette }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(8),
    width: '100%',
    maxWidth: '100%',
  },
  label: {
    fontSize: spacing(14),
    color: Theme.Colors.Grayscale.Eighty,
    fontWeight: Theme.Typography.FontWeight.Medium,

    '&.Mui-disabled': {
      color: Theme.Colors.Grayscale.Sixty,
    },
  },
  required: {
    color: Theme.Colors.Red.Base,
    marginLeft: spacing(4),
  },
  errorMessage: {
    color: `${palette.error.main} !important`,
    margin: 0,
    fontSize: spacing(10.5),
    fontFamily: 'Roboto',
    height: spacing(10),
    display: 'flex !important',
  },
}))
